import request from './request.js';
import {requestbody} from './request.js'

//初始化
export async function yhs_csh(params = {
}) {
return await requestbody('stamp/init', 'post', params)
}

//印花税功能操作接口
export async function yhs_fycx(params = {
}) {
return await requestbody('stamp/query', 'post', params)
}

//印花税上传文件

export async function stamp_uploadFile_api(params = {
}) {
return await request('stamp/detail/import', 'post', params)
}

//印花税明细登记

export async function stampdetailsquery(params = {
}) {
return await requestbody('stamp/details/query', 'post', params)
}

//

export async function stampdetailsshuimquery(params = {
}) {
return await requestbody('stamp/details/shuim/query', 'post', params)
}
//

export async function suosqbetweenquery(params = {
}) {
return await requestbody('stamp/suosqbetween/query', 'post', params)
}
export async function detailsadd(params = {
}) {
return await requestbody('stamp/details/add', 'post', params)
}
export async function detailsupdate(params = {
}) {
return await requestbody('stamp/details/update', 'post', params)
}
export async function detailssinglequery(params = {
}) {
return await request('stamp/details/single/query', 'post', params)
}
export async function detailsdelete(params = {
}) {
return await requestbody('stamp/details/delete', 'post', params)
}
//印花税税目
export async function sysYhsSm(params = {

}) {
    return await requestbody('/sys/getYhsSm', 'post', params)
}
export async function taxyhs(params = {

}) {
    return await requestbody('/sys/tax/edit/yhs', 'post', params)
}
export async function edityhs(params = {

}) {
    return await requestbody('/sys/edit/yhs', 'post', params)
}

export async function getCompanyByNsrsbh(params = {

}) {
    return await request('/sys/getCompanyByNsrsbh', 'get', params)
}

export async function dateclear(params = {

}) {
    return await requestbody('/stamp/date/clear', 'post', params)
}
